var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "compare-form",
          attrs: {
            model: _vm.compareItem.compareCalc,
            "label-width": "80px",
            size: "mini",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("chart.compare_date") } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t("chart.pls_select_field"),
                    size: "mini",
                  },
                  on: { change: _vm.initCompareType },
                  model: {
                    value: _vm.compareItem.compareCalc.field,
                    callback: function ($$v) {
                      _vm.$set(_vm.compareItem.compareCalc, "field", $$v)
                    },
                    expression: "compareItem.compareCalc.field",
                  },
                },
                _vm._l(_vm.fieldList, function (field) {
                  return _c("el-option", {
                    key: field.id,
                    attrs: {
                      label:
                        field.name +
                        "(" +
                        _vm.$t("chart." + field.dateStyle) +
                        ")",
                      value: field.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("chart.compare_type") } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.compareItem.compareCalc.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.compareItem.compareCalc, "type", $$v)
                    },
                    expression: "compareItem.compareCalc.type",
                  },
                },
                _vm._l(_vm.compareList, function (radio) {
                  return _c(
                    "el-radio",
                    { key: radio.value, attrs: { label: radio.value } },
                    [_vm._v(_vm._s(_vm.$t("chart." + radio.value)))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("chart.compare_data") } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.compareItem.compareCalc.resultData,
                    callback: function ($$v) {
                      _vm.$set(_vm.compareItem.compareCalc, "resultData", $$v)
                    },
                    expression: "compareItem.compareCalc.resultData",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "sub" } }, [
                    _vm._v(_vm._s(_vm.$t("chart.data_sub"))),
                  ]),
                  _c("el-radio", { attrs: { label: "percent" } }, [
                    _vm._v(_vm._s(_vm.$t("chart.data_percent"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("chart.compare_calc_expression") } },
            [
              _vm.compareItem.compareCalc.resultData === "sub"
                ? _c("span", { staticClass: "exp-style" }, [
                    _vm._v("本期数据 - 上期数据"),
                  ])
                : _vm.compareItem.compareCalc.resultData === "percent"
                ? _c("span", { staticClass: "exp-style" }, [
                    _vm._v("(本期数据 / 上期数据 - 1) * 100%"),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }